import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getBackendAPIClient } from "@lib/backendAPIClient";
import { mcpConnectionContract } from "@common/contracts/mcp-connection.contract";
import type { McpConnection } from "@common/schemas/domains/mcp/mcp-connection.schema";

const mcpConnectionsClient = getBackendAPIClient(mcpConnectionContract);

const mcpConnectionQueryKeys = {
    list: () => ["mcp-connections", "list"] as const,
};

export function useMcpConnectionsQuery() {
    return useQuery({
        queryKey: mcpConnectionQueryKeys.list(),
        queryFn: async (): Promise<McpConnection[]> => {
            const result = await mcpConnectionsClient.list();
            if (result.status !== 200) {
                throw new Error(
                    `Failed to load MCP connections (status ${result.status})`,
                );
            }
            return result.body.connections;
        },
    });
}

export function useRevokeMcpConnectionMutation() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (id: string) => {
            const result = await mcpConnectionsClient.revoke({
                params: { id },
            });
            if (result.status !== 200) {
                throw new Error(
                    `Failed to revoke MCP connection (status ${result.status})`,
                );
            }
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: mcpConnectionQueryKeys.list(),
            });
        },
    });
}
